export default function validateText(value) {
	const pattern = /^[\s]+$/
	if (value.length === 0 || pattern.test(value)) {
		return false
	}

	return true
}
